/**
 * Mousai Commerce — before / after slider
 *
 * The range input IS the control. It sits invisibly over the frame at full
 * size, which gives pointer drag, touch drag, keyboard arrows and screen
 * reader support for free — no custom drag maths, no synthetic events.
 * All the JS does is mirror its value into a CSS variable.
 */
(() => {
  const init = (root) => {
    root.querySelectorAll('[data-before-after]').forEach((el) => {
      if (el.dataset.baReady) return;
      el.dataset.baReady = 'true';

      const range = el.querySelector('[data-ba-range]');
      const frame = el.querySelector('.ba__frame');
      if (!range || !frame) return;

      const isRtl = getComputedStyle(el).direction === 'rtl';

      const paint = () => {
        const value = Number(range.value);
        // In RTL the clip and handle read from the opposite edge, so the
        // visual position is mirrored while the input value stays natural.
        frame.style.setProperty('--ba-pos', `${isRtl ? 100 - value : value}%`);
      };

      range.addEventListener('input', paint);
      paint();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  }
})();
